import { NotImplementedError } from "../../../../errors";
import { normalizeUserEmail, PARTNER_LOGO_VIEWER_EMAIL_FILTER } from "../../../../models/looker/modules/overview";
import { PromiseHandler } from "../../../../handlers";
import { PARTNER_LOGO_QUERY } from "./query";
export default class LookerOverviewPartnerLogo extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-overview-partner-logo");
    }
    async findItems(filters) {
        const queryBody = {
            ...PARTNER_LOGO_QUERY,
            filters: {
                ...PARTNER_LOGO_QUERY.filters
            }
        };
        // Fail closed: the partner logo is scoped exclusively by the user email
        // filter. Without a usable email the Looker query would return an
        // arbitrary partner's logo (a cross-tenant leak), so we refuse to run it.
        const userEmailFilter = filters.where?.find((filter) => filter.field === "userEmail");
        const userEmail = normalizeUserEmail(userEmailFilter?.value);
        if (!userEmail) {
            throw new Error("User email is required");
        }
        queryBody.filters[PARTNER_LOGO_VIEWER_EMAIL_FILTER] = userEmail;
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch overview dashboard partner logo");
        }));
    }
    formatResponse(data) {
        return [
            {
                logoUrl: data[0]?.["viewer_partner_logo.logo_url"] || null
            }
        ];
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=PartnerLogo.js.map